import fallback_logo from "../assets/images/XS-Lernix-logo.png";
import { useTheme } from "../contexts/ThemeContext";
import { assetUrl } from "../utils/galleryUtils";

const DEFAULT_BRAND_NAME = "XS Learnix";

export default function usePortalBranding() {
  const { publicPortalSetting, publicBrandingReady } = useTheme();
  const ps = publicPortalSetting || {};

  const brandName =
    (ps.brand_name && String(ps.brand_name).trim()) || DEFAULT_BRAND_NAME;
  const logoSrc =
    ps.brand_logo && String(ps.brand_logo).trim()
      ? assetUrl(ps.brand_logo) || fallback_logo
      : fallback_logo;

  return {
    publicBrandingReady,
    brandName,
    logoSrc,
    portalSetting: ps,
    defaultBrandName: DEFAULT_BRAND_NAME,
    fallbackLogo: fallback_logo,
  };
}
